import React from 'react';
import './sx-icon-core.css';
import type { ReactNode, SVGProps } from 'react';

export interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
  viewBox?: string;
  children?: ReactNode;
  className?: string;
}

const SvgIcon: React.FC<SvgIconProps> = ({
  size = 24,
  color,
  children,
  style,
  viewBox = '0 0 24 24',
  className,
  ...props
}) => {
  const styles: React.CSSProperties = {
    display: 'inline-block',
    userSelect: 'none',
    flexShrink: 0,
    ...(color ? { fill: color } : {}),
    ...style,
  };

  return (
    <svg
      viewBox={viewBox}
      height={size}
      width={size}
      fill={color}
      style={styles}
      className={`sx-svg-icon--${className ? ' ' + className : ''}`}
      focusable="false"
      {...props}
    >
      {children}
    </svg>
  );
};

export default SvgIcon;
